import { get, post } from "@/libs/http";
import { BindAgentReq, BindAgentRes } from "@/types/api/agent/bind-agent.d";
import { FaqReq, FaqRes } from "@/types/api/agent/faq.d";
import { InviteCodeReq, InviteCodeRes } from "@/types/api/agent/invite-code.d";
import { InviteShareReq, InviteShareRes } from "@/types/api/agent/invite-share.d";
import { MyRewardListReq, MyRewardListRes } from "@/types/api/agent/my-reward-list.d";
import { MyRewardReq, MyRewardRes } from "@/types/api/agent/my-reward.d";
import { StatusReq, StatusRes } from "@/types/api/agent/status.d";
import { TestReq, TestRes } from "@/types/api/agent/test.d";
import { UserDetailReq, UserDetailRes } from "@/types/api/agent/user-detail.d";
import { WelfareReq, WelfareRes } from "@/types/api/agent/welfare.d";
import { WithdrawCommissionListReq, WithdrawCommissionListRes } from "@/types/api/agent/withdraw-commission-list.d";
import { WithdrawCommissionReq, WithdrawCommissionRes } from "@/types/api/agent/withdraw-commission.d";
import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { createApiQuery } from "@/hooks/use-api-query";

// 绑定代理
export const bindAgent = ({ params }: { params: BindAgentReq; }) => {
  return post<BindAgentRes>('/user/agent/v1/bind/agent', params);
};

// 获取代理FAQ
export const getAgentFaq = ({ params }: { params: FaqReq; }) => {
  return get<FaqRes>('/user/agent/v1/faq', { params });
};

// 获取邀请码
export const getInviteCode = ({ params }: { params: InviteCodeReq; }) => {
  return get<InviteCodeRes>('/user/agent/v1/invite/code', { params });
};

// 获取邀请分享页面
export const getInviteShare = ({ params }: { params: InviteShareReq; }) => {
  return get<InviteShareRes>('/user/agent/v1/invite/share', { params });
};

// 获取我的奖励列表
export const getMyRewardList = ({ params }: { params: MyRewardListReq; }) => {
  return get<MyRewardListRes>('/user/agent/v1/my/reward/list', { params });
};

// 获取我的奖励
export const getMyReward = ({ params }: { params: MyRewardReq; }) => {
  return get<MyRewardRes>('/user/agent/v1/my/reward', { params });
};

// 获取代理活动状态
export const getAgentStatus = ({ params }: { params: StatusReq; }) => {
  return get<StatusRes>('/user/agent/v1/status', { params });
};

// 获取测试数据
export const getAgentTest = ({ params }: { params: TestReq; }) => {
  return get<TestRes>('/user/agent/v1/test', { params });
};

// 获取代理用户详情
export const getAgentUserDetail = ({ params }: { params: UserDetailReq; }) => {
  return get<UserDetailRes>('/user/agent/v1/user/detail', { params });
};

// 获取代理福利
export const getAgentWelfare = ({ params }: { params: WelfareReq; }) => {
  return get<WelfareRes>('/user/agent/v1/welfare', { params });
};

// 获取领取佣金明细列表
export const getWithdrawCommissionList = ({ params }: { params: WithdrawCommissionListReq; }) => {
  return get<WithdrawCommissionListRes>('/user/agent/v1/withdraw/commission/list', { params });
};

// 领取佣金
export const withdrawCommission = ({ params }: { params: WithdrawCommissionReq; }) => {
  return post<WithdrawCommissionRes>('/user/agent/v1/withdraw/commission', params);
};

// ================ Hooks ================

// 绑定代理的 Hook
export const useBindAgent = createApiMutationHook(bindAgent);

// 获取代理FAQ的 Hook
export const useGetAgentFaq = createApiQuery(getAgentFaq, (params) => ['agent-faq', params.params.page, params.params.page_size]);

// 获取邀请码的 Hook
export const useGetInviteCode = createApiQuery(getInviteCode, (params) => ['invite-code', params.params.type]);

// 获取邀请分享页面的 Hook
export const useGetInviteShare = createApiQuery(getInviteShare, () => ['invite-share']);

// 获取我的奖励列表的 Hook
export const useGetMyRewardList = createApiQuery(getMyRewardList, (params) => ['my-reward-list', params.params.category, params.params.date_type, params.params.page, params.params.page_size]);

// 获取我的奖励的 Hook
export const useGetMyReward = createApiQuery(getMyReward, () => ['my-reward']);

// 获取代理活动状态的 Hook
export const useGetAgentStatus = createApiQuery(getAgentStatus, () => ['agent-status']);

// 获取测试数据的 Hook
export const useGetAgentTest = createApiQuery(getAgentTest, (params) => ['agent-test', params.params.type]);

// 获取代理用户详情的 Hook
export const useGetAgentUserDetail = createApiQuery(getAgentUserDetail, () => ['agent-user-detail']);

// 获取代理福利的 Hook
export const useGetAgentWelfare = createApiQuery(getAgentWelfare, () => ['agent-welfare']);

// 获取领取佣金明细列表的 Hook
export const useGetWithdrawCommissionList = createApiQuery(getWithdrawCommissionList, (params) => ['withdraw-commission-list', params.params.page, params.params.page_size]);

// 领取佣金的 Hook
export const useWithdrawCommission = createApiMutationHook(withdrawCommission);
